



































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';

@Component
export default class DeclarationsList extends Vue {
    @Prop({ default: () => ({ Declarations: [] }) })
    private order!: Order & { Declarations?: any[] };

    private getStatusName(status: number): string {
        switch (status) {
            case 1: return 'Khởi tạo';
            case 2: return 'Đã chốt khách';
            case 3: return 'Gửi Kê Khai';
            case 5: return 'HQ Sửa';
            case 6: return 'Đã Nhập Khẩu';
            default: return 'Khởi tạo';
        }
    }

    private getStatusColor(status: number): string {
        switch (status) {
            case 1: return '#64748b'; // Slate
            case 2: return '#2563eb'; // Blue
            case 3: return '#f97316'; // Orange
            case 5: return '#e11d48'; // Red
            case 6: return '#16a34a'; // Green
            default: return '#64748b';
        }
    }
}
